"use strict";
/* eslint-disable no-console */
import firebase from "../plugins/firebase";

// 登録ユーザモデル
class User {
  // コンストラクタ
  constructor() {
    // メールアドレス
    this.email = "";
    // 表示名(ニックネーム)
    this.displayName = "";
    // 会員番号
    this.number = 0;
    // uid
    this.uid = "";
    // 誕生日
    this.birthday = "";
    // 名前
    this.name = "";
    // 名前(カナ)
    this.name_kana = "";
    // ホームジムID
    this.homeGymId = "";
    // 電話番号
    this.phoneNumber = "";
    // レッドポイント
    this.rp = "";
    // オンサイト
    this.os = "";
    // 権限
    this.state = 2;
    // 受講コース
    this.course = "";
    // ラブ
    this.love = [];
    // 子どもの登録
    this.kids = [];
    // 退会者
    // 0:入会中 1:退会済
    this.del = "0";
    // 登録日
    this.create_at = firebase.firestore.Timestamp.now();
    // 更新日
    this.update_at = firebase.firestore.Timestamp.now();
  }
  // アクセサ
  // get email() {
  //   console.log("ゲットした！！！！")
  //   return this._email;
  // }
  // set email(value) {
  //   this._email = value;
  //   console.log("セットした！！！！")
  // }
  // get displayName() {
  //   return this._displayName;
  // }
  // set displayName(value) {
  //   this._displayName = value;
  // }
  // get number() {
  //   return this._number;
  // }
  // set number(value) {
  //   this._number = value;
  // }
  // get uid() {
  //   return this._uid;
  // }
  // set uid(value) {
  //   this._uid = value;
  // }
  // get birthday() {
  //   return this._birthday;
  // }
  // set birthday(value) {
  //   this._birthday = value;
  // }
  // get name() {
  //   return this._name;
  // }
  // set name(value) {
  //   this._name = value;
  // }
  // get name_kana() {
  //   return this._name_kana;
  // }
  // set name_kana(value) {
  //   this._name_kana = value;
  // }
  // get homeGymId() {
  //   return this._homeGymId;
  // }
  // set homeGymId(value) {
  //   this._homeGymId = value;
  // }
  // get phoneNumber() {
  //   return this._phoneNumber;
  // }
  // set phoneNumber(value) {
  //   this._phoneNumber = value;
  // }
  // get rp() {
  //   return this._rp;
  // }
  // set rp(value) {
  //   this._rp = value;
  // }
  // get os() {
  //   return this._os;
  // }
  // set os(value) {
  //   this._os = value;
  // }
  // get state() {
  //   return this._state;
  // }
  // set state(value) {
  //   this._state = value;
  // }
  // get course() {
  //   return this._course;
  // }
  // set course(value) {
  //   this._course = value;
  // }
  // get kids() {
  //   return this._kids;
  // }
  // set kids(value) {
  //   this._kids = value;
  // }
  // get del() {
  //   return this._del;
  // }
  // set del(value) {
  //   this._del = value;
  // }
  // 更新時間は取得のみ
  // get update_at() {
  //   return this._update_at;
  // }
}
User.prototype = {
  // オブジェクトをプロパティにセットする
  setObject(obj) {
    for (const i in this) {
      for (const n in obj) {
        if (i.indexOf(n) > -1) {
          this[i] = obj[n];
        }
      }
    }
    return this;
  },
  // ユーザオブジェクトを取得する
  getObject() {
    var obj = {};
    for (const key in this) {
      if (Object.hasOwnProperty.call(this, key)) {
        const element = this[key];
        obj[key] = element;
      }
    }
    return obj;
  },
};

export default User;
